// extracted by mini-css-extract-plugin
export default {"root":"Features_root__gBOzG","header":"Features_header__8aQd0","grid":"Features_grid__p6rEw","inviteButton":"Features_inviteButton__kQKPg"};